import { createAction } from 'redux-actions';

export const drawerOpen = createAction('DRAWER_OPEN');
export const drawerClose = createAction('DRAWER_CLOSE');

export default {
  drawerOpen,
  drawerClose,
};
